import React from "react";
import { BaseSvgIcon, createIcon } from "../IconBase";
// GENERATED from custom/src/approved.svg by scripts/generate-icons.mjs. Do not edit
// by hand — edit the source SVG and regenerate.
const ApprovedIconGlyph = (props) => (React.createElement(BaseSvgIcon, { ...props },
    React.createElement("path", { d: "M6 12.5l4 4 8-9", fill: "none", stroke: "currentColor", strokeWidth: "2.6", strokeLinecap: "round", strokeLinejoin: "round" })));
export const ApprovedIcon = createIcon(ApprovedIconGlyph, "ApprovedIcon", "0 0 24 24");
//# sourceMappingURL=ApprovedIcon.js.map